import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { default as __ } from '../../utils';
import Title from '../../components/title';
import Level from '../profile/level';
import Pala from '../profile/pala';
import Avatar from '../profile/avatar';
import { default as API } from '../../api';
import { default as UI_ACTIONS } from '../../reducers/ui';
import { default as SESSION_ACTIONS } from '../../reducers/session';
import { useUser } from '../../context/user';

function ConnectedOnBoarding(props) {
  const { notifyUser, tryChangeLevel, user, left } = props;
  const { userOnline } = useUser();
  let { sessionId } = user;

  let saveNewLevel = newLevel => {
    API.updateKey(sessionId, 'level', newLevel)
      .then(_ =>
        __.callAll(tryChangeLevel(newLevel), notifyUser('', false, 'success')),
      )
      .catch(o_O => notifyUser(o_O.code, false, 'success'));
  };
  return (
    <main className="owl ">
      <Title
        label={'más'}
        vertices={9}
        value={__.pluralize(left, 'partidx', 's')}
        xl
      />
      <br />
      {
        {
          3: (
            <>
              <br />
              <br />

              <Level level={user.level} cb={saveNewLevel} />
              <p className="txt-uppercase -darkgrey txt-center">
                Añade tu nivel
              </p>
            </>
          ),
          2: (
            <div className="small-container owl">
              <Pala />
              <p className="txt-uppercase -darkgrey txt-center">
                Puedes añadir tu pala
              </p>
            </div>
          ),
          1: (
            <>
              <Avatar />
              <p className="txt-uppercase -darkgrey txt-center">
                Puedes customizar tu avatar{' '}
              </p>
            </>
          ),
        }[left]
      }
    </main>
  );
}

const select = state => {
  return {
    user: state.session.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    notifyUser: msg => dispatch(UI_ACTIONS.showFeedback(msg)),
    tryChangeLevel: level => dispatch(SESSION_ACTIONS.changeLevel(level)),
  };
};

const OnBoarding = connect(select, mapDispatchToProps)(ConnectedOnBoarding);
export default OnBoarding;
